/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/13/14
 * Time: 4:14 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/categories/categoriesTableLayout.tmpl");
    var Button = require("ui/button/Button");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var Paging = require("ui/paging/Paging");

    var CategoriesTableLayout = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesTableLayout = Marionette.Layout.extend({
            template: template,
            className: "categories-table-layout",
            regions: {
                tableRegion:      ".table-container"
            },
            ui: {
                viewContainer            : ".view-container",
                actionMenuStrip            : ".page-action-strip",
                actionMenuContainer      : ".action-menu",
                doneButton               : ".button-done",
                addNewCategoryWrap       : ".add-new-category-wrap",
                categoriesPagingContainer: ".categories-paging-container"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.categoriesPagingContainer",
                        collection: "view.collection"
                    }
                },
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionsCollection",
                        tabindex: "1000"
                    },
                    events: {
                        "change":"_onActionSelected"
                    }
                },
                doneBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.doneButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_done"
                    }
                },
                addNewBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.addNewCategoryWrap",
                        permutation: Button.PERMUTATION.BTN
                    },
                    events: {
                        "click": "_onAddCategory"
                    }
                }
            },

            initialize: function (options) {
                this.vent = options.vent;
                this.hasEditPrivileges = options.hasEditPrivileges;
                this.listenTo(this.vent, "categoryTableLayout:addCategoryEnabled", this.enableAddAction);
                this.listenTo(this.vent, "categoryTableLayout:deleteCategoryEnabled", this.enableDeleteAction);
            },
            onRender: function () {
                LEManager.logger.debug("onRender CategoriesTableLayout", "CategoriesTableLayout:onRender");
                this.listenTo(this, "page:closeButtonClick", this._onCloseButtonClick);

                if (!this.hasEditPrivileges) {
                    this.ui.actionMenuStrip.addClass("hide");
                    this.ui.addNewCategoryWrap.addClass("hide");
                }
            },
            /**
             * Handles the selected action
             * @param id
             */
            _onActionSelected: function(componentId, eventName, id){
                LEManager.logger.info("Categories table: user clicked on menu action: " + id, "CategoriesTableLayout:onActionSelected");
                switch (id) {
                    case "add":
                        this._onAddCategory();
                        break;
                    case "delete":
                        this._onDeleteCategory();
                        break;
                    default:
                        break;
                }
            },
            _onAddCategory: function() {
                if (this.hasEditPrivileges) {
                    this.vent.trigger("categoryTableLayout:actions:new");
                }
            },
            _onDeleteCategory: function() {
                if (this.hasEditPrivileges) {
                    this.vent.trigger("categoryTableLayout:actions:delete");
                }
            },

            _done: function () {
                LEManager.logger.info("User clicked on 'done' button.", "CategoriesTableLayout::_done");
                this.vent.trigger("categoryTableLayout:buttons:done");
            },
            _onCloseButtonClick: function (){
                LEManager.logger.info("User clicked on 'close window' button.", "CategoriesTableLayout::_closeWindowButtonClicked");
                this.vent.trigger("categoryTableLayout:buttons:close");
            },

            _getActionsCollection: function() {
                this.actionsCollection = new DropdownMenu.Collection([
                    { id:"add", "actionName":LE.translator.translate("LEFramework.global.captions.add"), "enabled":true, "title":LE.translator.translate("LEManager.categories.list.actions.add.tooltip"), "align": "right"},
                    { id:"delete", "actionName":LE.translator.translate("LEFramework.global.captions.delete"), "enabled":false, "title":LE.translator.translate("LEManager.categories.list.actions.delete.tooltip"), "align": "right"}
                ]);
                return this.actionsCollection;
            },

            /**
             * Called by the controller to enable or disable the new action in the menu (according to how many categories there is)
             * @param enabled
             */
            enableAddAction: function(enabled) {
                var tooltip = (enabled) ? LE.translator.translate("LEManager.categories.list.actions.add.tooltip") :
                                          LE.translator.translate("LEManager.categories.list.actions.add.error.tooltip").replace("{0}", LEManager.getDataManager().getCategoriesCollectionMaxSize());

                this.actionsCollection.get("add").set({"enabled": enabled, "title":tooltip});

                this.uiComponents.addNewBtn.setTooltip(tooltip, "left");
                this.uiComponents.addNewBtn.setEnabled(enabled);
            },

            /**
             * Called by the controller to enable or disable the delete action in the menu
             * @param enabled
             */
            enableDeleteAction: function(enabled) {
                var tooltip = (enabled) ? LE.translator.translate("LEManager.categories.list.actions.delete.tooltip") : "";
                this.actionsCollection.get("delete").set({"enabled": enabled, "title":tooltip});
            },

            onClose: function () {
                LEManager.logger.info("closing categories table layout view", "CategoriesTableLayout::onClose");
            }
        });
    });
    return CategoriesTableLayout;
});
